export const STORAGE_KEYS = {
    featurePromosVisited: 'featureDialogsVisited',
    anniversaryShown: 'anniversaryPromoShown',
    oldUsersSeen: 'hasSeenOldUsers',
    oldUsersPromoShownAtVisit: 'oldUsersPromoShownAtVisit',
    visitsCounter: 'paywallVisitsCounter',
    audacityAudioPaywallSeen: 'HAS_SEEN_AU_AUDIO_PAYWALL',
    hqStoragePaywallSeen: 'hasSeenHqStoragePaywall',
    creatorProfileOfferShownAt: 'creatorProfileOfferShownAt',
} as const
